import { render, staticRenderFns } from "./RedeemDetail.vue?vue&type=template&id=be29cba6&scoped=true&"
import script from "./RedeemDetail.vue?vue&type=script&lang=js&"
export * from "./RedeemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be29cba6",
  null
  
)

export default component.exports